export const queryKeys = {
  reports: {
    all: ["reports"] as const,
    // tenantId scopes the cache per tenant so switching tenants restores
    // each tenant's previously fetched data instantly instead of refetching.
    list: (tenantId: number | undefined) => [...queryKeys.reports.all, "list", tenantId] as const,
    allParameters: () => [...queryKeys.reports.all, "parameters"] as const,
    parameters: (reportPath: string, params?: Record<string, string | string[]>) =>
      [...queryKeys.reports.all, "parameters", reportPath, params] as const,
  },
  reportLists: {
    all: ["report-lists"] as const,
    list: (tenantId: number | undefined) => [...queryKeys.reportLists.all, "list", tenantId] as const,
    detail: (key: string) =>
      [...queryKeys.reportLists.all, "detail", key] as const,
  },
  reportListItems: {
    all: ["report-list-items"] as const,
    byList: (listKey: string) =>
      [...queryKeys.reportListItems.all, "by-list", listKey] as const,
    detail: (itemKey: string) =>
      [...queryKeys.reportListItems.all, "detail", itemKey] as const,
  },
  deliveryTypes: {
    all: ["delivery-types"] as const,
  },
  projects: {
    all: ["projects"] as const,
    list: (tenantId: number | undefined) => [...queryKeys.projects.all, "list", tenantId] as const,
  },
  version: {
    all: ["version-info"] as const,
  },
  tenant: {
    all: ["current-tenant"] as const,
  },
  thumbnails: {
    all: ["thumbnails"] as const,
    thumbnail: (reportName: string) =>
      [...queryKeys.thumbnails.all, "thumbnail", reportName] as const,
  },
} as const
